import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../settlements'

import { SettlementPopup } from "../components/settlement-popup.component";
import { updateNestedValue } from "../../../../../../common/services/common.service";
import { MdTableView } from "react-icons/md";
import { SettlementRequestItemsPopup } from "../../settlement-request-items/containers/settlement-request-items-popup";
import { selectSettlementCreatedItem, selectSettlementDeletedItem, selectSettlementsListItems, selectSettlementUpdatedItem } from "../../../../../../redux/settlement-hub/settlements/selector";
import { settlements } from "../../../../../../redux/settlement-hub/settlements/action";
import { SettlementItemsPopup } from "../../settlement-items/containers/settlement-items-popup";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { libraryData, NP_NP, TO_BE_INITIATED } from "../../constants/constants";

const Settlements = ({
  
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showSettlementPopup, setShowSettlementPopup] = useState<boolean>(false);
  const [showSettlementItemsPopup, setShowSettlementItemsPopup] = useState<boolean>(false);
  const [selectedSettlement, setSelectedSettlement] = useState<any>({
    "Id": 0,
    "OrderId": "",
    "CollectorAppId": "",
    "ReceiverAppId": "",
    "SettlementTypeId": NP_NP,        
    "SettlementStatusId": TO_BE_INITIATED
});

  const [listItems, setListItems] = useState<any>([]);
  const listOfSettlementsData = useSelector(selectSettlementsListItems)
  const createSettlementRequestsData = useSelector(selectSettlementCreatedItem)
  const updateSettlementRequestsData = useSelector(selectSettlementUpdatedItem)
  const deleteSettlementsRequestsData = useSelector(selectSettlementDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});  
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'SettlementRequestId', headerName: 'Settlement Request Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'CollectorAppId', headerName: 'Collector', sortable: true, filter: true, filterType: 'text', },
      { field: 'ReceiverAppId', headerName: 'Receiver', sortable: true, filter: true, filterType: 'text', },
      { field: 'SettlementTypeId', headerName: 'Type', sortable: true, filter: true, filterType: 'text', },
      { field: 'SettlementStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: '', headerName: 'Items', sortable: false, filter: false, cellRenderer: 'customFunctions'},

    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedSettlement, path, value', selectedSettlement, path, value)
    const updatedData = updateNestedValue(selectedSettlement, path, value)

    console.log('updatedData', updatedData)
    setSelectedSettlement({...updatedData});
  }

  const handleAddSettlement = () => {    
    setSelectedSettlement({
      "Id": 0,
      "OrderId": "",
      "CollectorAppId": "",
      "ReceiverAppId": "",
      "SettlementTypeId": NP_NP,        
      "SettlementStatusId": TO_BE_INITIATED
  })
    setShowSettlementPopup(true)
  }

  const handleInitiateSettlement = () => {
    
  }

  const handleReconciliation = () => {

  }

  const handleEdit = (data: any) => {
    setSelectedSettlement(data)
    setShowSettlementPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.SettlementRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(settlements.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlements/delete`,
      entity: 'settlements',
      jsonData: {
        Context:{},
        Records: [{Id: data?.SettlementRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Add Settlement</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   // name: 'Add Settlement',
    //   callback: () => handleAddSettlement(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Initiate Reconciliation</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      name: 'Initiate Reconciliation',
      callback: () => handleReconciliation(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleSettlementItems =(item: any) => {
    setShowSettlementItemsPopup(true)
  }

  const customFunctions = [
    {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSettlementItems, title: "Show Settlement Items"},
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  const handleReloadData = () => {
    listSettlements();
  }

  const listSettlements = async () => {
    console.log('settlements')
    await dispatch(settlements.resetAction({actionType:'list'}))
    await dispatch(settlements.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlements/list`,
      entity: 'settlements',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveSettlement = async (selectedSettlement: any) => {
    if (selectedSettlement?.Id > 0) {
      await dispatch(settlements.resetAction({actionType:'update'}))
      await dispatch(settlements.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlements`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlement
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(settlements.resetAction({actionType:'update'}))
      await dispatch(settlements.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlements`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlement
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listSettlements();
  }

  const closeModal = () => {
    setShowSettlementPopup(false)
  }

  const closeItemsModal = () => {
    setShowSettlementItemsPopup(false)
  }

  useEffect(() => {
    console.log('listOfSettlementsData', listOfSettlementsData)
    // if(listOfSettlementsData?.isSuccess){
      if(listOfSettlementsData?.result?.items && listOfSettlementsData?.result?.items?.length > 0)
      {
        console.log('listOfSettlementsData?.result?.items[0].Error', listOfSettlementsData?.result?.items[0].Error)
        if (listOfSettlementsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfSettlementsData?.result?.items)
        }     
      }  else {
        setListItems(orderData)
      }    
    // }
  }, [listOfSettlementsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listSettlements();
  }, [deleteSettlementsRequestsData]);

  useEffect(() => {
    createColumnDefs()
    listSettlements()
  }, [pageData, pageSize])

  return (
    <>
      {
        showSettlementPopup ?
          <SettlementPopup
            selectedSettlement={selectedSettlement}
            closeModal={closeModal}
            handleSaveSettlement={handleSaveSettlement}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {
        showSettlementItemsPopup ?
          <SettlementItemsPopup
            selectedSettlement={selectedSettlement}
            closeModal={closeItemsModal}
            handleSaveSettlement={handleSaveSettlement}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {listOfSettlementsData?.isLoading || deleteSettlementsRequestsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfSettlementsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Settlements" />
      }
    </>
  );
};

export default Settlements;


